import { Icon } from "metabase/ui";

export const XrayIcon = () => {
  return <Icon name="bolt" size={24} c="accent4" />;
};
